// Streams inside a session window's pane, in the DOM renderer (render-dom.js): each stream's canvas lives in the
// pane's slot (`<div data-embed-window="<window id>">`). The pane redraws its HTML with every change, which drops
// the canvas with the old slot, so the canvas is put back as soon as the host's DOM changes (a MutationObserver on
// the host window), and on a slow tick for anything that slips past it.
//
// One seam: `new DomEmbeds(app)` → `add(spec)`, `remove(spec)`, `place()`.

export class DomEmbeds {
  constructor(app) {
    this.app = app
    this.timer = null
    this.watch = new Map()   // host root → its MutationObserver
  }

  add(spec) {
    spec.canvas.classList.add('dw-embed')
    if (!this.timer) this.timer = setInterval(() => this.place(), 300)
    const root = spec.embed?.dom?.root
    if (root && !this.watch.has(root)) {
      const w = new MutationObserver(() => this.place())
      w.observe(root, { childList: true, subtree: true })
      this.watch.set(root, w)
    }
    this.place()
  }

  remove(spec) {
    spec.canvas?.remove()
    const others = this.app.streams.filter((x) => x.embed && x !== spec)
    for (const [root, w] of this.watch) if (!others.some((x) => x.embed.dom?.root === root)) { w.disconnect(); this.watch.delete(root) }
    if (!others.length) { clearInterval(this.timer); this.timer = null }
  }

  place() {
    for (const spec of this.app.streams) {
      if (!spec.embed) continue
      const root = spec.embed.dom?.root
      const slot = root?.querySelector(`[data-embed-window="${spec.window.id}"]`)
      if (slot && spec.canvas.parentElement !== slot) slot.appendChild(spec.canvas)
      if (!slot && spec.canvas.parentElement) spec.canvas.remove()
    }
  }
}
